import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silence the benign "ResizeObserver loop" browser warning (fired by Radix
// dialogs/comboboxes resizing) so it doesn't trip the dev error overlay.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeRO = window.ResizeObserver;
  window.ResizeObserver = class extends NativeRO {
    constructor(cb) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try { cb(entries, observer); } catch (_) { /* ignore */ }
        });
      });
    }
  };
  const isROError = (m) => typeof m === "string" && m.includes("ResizeObserver loop");
  window.addEventListener("error", (e) => {
    if (isROError(e.message)) { e.stopImmediatePropagation(); e.preventDefault(); }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
